export type CustomerStatus = "lead" | "active" | "inactive";

// Acquisition source — where the customer first found the dealership.
// Mirrors the Go typed-strings in customers/domain/customer.go and the
// lead_source Postgres enum (migration 000038). "" = unknown.
export type LeadSource =
  | "walk_in"
  | "website"
  | "phone"
  | "boat_show"
  | "social_media"
  | "referral"
  | "repeat_customer"
  | "other";

export const LEAD_SOURCE_LABELS: Record<LeadSource, string> = {
  walk_in: "Walk-in",
  website: "Website",
  phone: "Phone",
  boat_show: "Boat show",
  social_media: "Social media",
  referral: "Referral",
  repeat_customer: "Repeat customer",
  other: "Other",
};

export interface Customer {
  id: string;
  first_name: string;
  last_name: string;
  company_name?: string;
  contact_email: string;
  phone: string;
  // Name of the assigned Sales-department employee ("" = unassigned).
  assigned_sales_rep: string;
  status: CustomerStatus;
  lead_source?: string;
  // The customer who referred them, when known.
  referred_by?: string | null;
  created_at: string;
  updated_at: string;
}
